const CryptoJS = require("crypto-js");

/*
    * Utility functions for encrypting and decrypting data using AES encryption.
*/

// Encrypts data 
const encryptData = (data) => {
    try {
        const ciphertext = CryptoJS.AES.encrypt(
            JSON.stringify(data),
            "f7K#9xP2$mQ8vL4nT6rW1zY5@cD3eH0"
        ).toString();
        return ciphertext;
    }
    catch (error) {
        console.error("Encryption error:", error);
        return null;
    }
};


// Decrypts data
const decryptData = (encryptedData) => {
    try {
        const bytes = CryptoJS.AES.decrypt
            (encryptedData.toString(), "f7K#9xP2$mQ8vL4nT6rW1zY5@cD3eH0");
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedData);
    }
    catch (error) {
        console.error("Decryption error:", error);
        return null;
    }
};

export { encryptData, decryptData };


//////////////////
// WEBPACK FOOTER
// ./utils/crypto_utils.js
// module id = 26
// module chunks = 1